import EN_US from "./en-US.json";
import JP from "./jp.json";

const languages = {
  en: EN_US,
  jp: JP,
};

export default languages;
